// extracted by mini-css-extract-plugin
export default {"root":"NoSearchResultsMaybe_root__jFPXw"};